export default __webpack_public_path__ + "static/media/grafix-logo.6401fefc.svg";